module.exports = __webpack_public_path__ + "img/1137011984.6a8973e2.jpg";